/* eslint-disable camelcase */
import React from 'react';
import WholeMeProfileSection from 'pages/wholeme/molecules/wholeMeProfileSection/WholeMeProfileSection';
import { createEditHandler } from 'pages/wholeme/util/profile_util';
import PillRenderer from 'common/molecules/pillRenderer/PillRenderer';
import WholeMeProfileSectionRow from 'pages/wholeme/molecules/wholeMeProfileSectionRow/WholeMeProfileSectionRow';
import WholeMeProfileSectionDetail from 'pages/wholeme/molecules/wholeMeProfileSectionDetail/WholeMeProfileSectionDetail';
import { CareerIcon } from 'pages/wholeme/icons/Icons';
import { fieldLabelFor } from '../../util/profile_field_data';
import { pillOverrideStyles, pillRendererOverrideStyles } from '../wholeMeProfileSection/wholeMeProfileSectionStyles';
import { firstValueOf } from '../../util/profile_util';

const WholeMeProfileCareerAspirations = ({
  profile, onEdit, isViewOnly,
}) => {
  const pillContainerOverrideStyles = isViewOnly
    ? pillRendererOverrideStyles
    : {
      ...pillRendererOverrideStyles,
      marginLeft: '22px',
    };
  const {
    career_stage = [], employers = [], career_fields = [], calendly_url = [],
  } = profile;
  if (
    career_stage?.length < 1
    && employers?.length < 1
    && calendly_url?.length < 1
    && !onEdit
  ) {
    if (!onEdit) {
      return null;
    }
    return (
      <WholeMeProfileSection
        title="Career Aspirations"
        editable={!!onEdit}
        onTitleClick={createEditHandler(onEdit, 'education')}
        isEmpty
      />
    );
  }

  const careerStage = career_stage?.find((n) => n.question_id === 'career_stage')?.option_id;
  const careerFields = career_fields?.filter((n) => n.value !== 'selected');
  const calendlyUrl = firstValueOf(calendly_url);

  const renderEdit = () => (
    <>
      <WholeMeProfileSectionDetail
        onEdit={onEdit}
        label="Career Stage"
        items={careerStage && [fieldLabelFor(careerStage, 'career', 'career_stage')]}
        categoryId="career"
        stepId="career_stage"
        isViewOnly={isViewOnly}
        pillStyles={{ backgroundColor: '#c4c4c4' }}
      />
      <WholeMeProfileSectionDetail
        onEdit={onEdit}
        label="Employers"
        items={employers.map((n) => n.value)}
        categoryId="career"
        stepId="employers"
        isViewOnly={isViewOnly}
        pillStyles={{ backgroundColor: '#c4c4c4' }}
      />
      <WholeMeProfileSectionDetail
        onEdit={onEdit}
        label="Career Path"
        items={careerFields.map((n) => n.value)}
        categoryId="career"
        stepId="career_fields"
        isViewOnly={isViewOnly}
        pillStyles={{ backgroundColor: '#c4c4c4' }}
      />
      <WholeMeProfileSectionDetail
        onEdit={onEdit}
        label="Calendly URL"
        items={calendlyUrl ? [calendlyUrl] : []}
        categoryId="career"
        stepId="calendly"
        isViewOnly={isViewOnly}
      />
    </>
  );

  const renderView = () => (
    <>
      {!!careerStage && (
        <WholeMeProfileSectionRow
          iconSrc="assets/icons/education-career/occupation-blue.svg"
          onEdit={onEdit}
          label={fieldLabelFor(careerStage, 'career', 'career_stage')}
        />
      )}
      {careerFields.length > 0 && (
        <PillRenderer
          pillStyles={{ ...pillOverrideStyles, backgroundColor: '#C4C4C4' }}
          containerStyleOverrides={pillContainerOverrideStyles}
          isSelectable={false}
          items={careerFields.map((n) => ({ value: n.value }))}
        />
      )}
      {employers.length > 0 && (
        <PillRenderer
          pillStyles={{ ...pillOverrideStyles, backgroundColor: '#C4C4C4' }}
          containerStyleOverrides={pillContainerOverrideStyles}
          isSelectable={false}
          items={employers.map((n) => ({ value: n.value }))}
        />
      )}
      {calendlyUrl && (
        <PillRenderer
          pillStyles={{ ...pillOverrideStyles, backgroundColor: '#C4C4C4' }}
          containerStyleOverrides={pillContainerOverrideStyles}
          isSelectable={false}
          items={calendlyUrl ? [calendlyUrl] : []}
        />
      )}
    </>
  );

  return (
    <WholeMeProfileSection
      title="Career Aspirations"
      editable={!!onEdit}
      titleIcon={<CareerIcon paddingRight=".25rem" />}
    >
      {!!onEdit && renderEdit()}
      {!onEdit && renderView()}
    </WholeMeProfileSection>
  );
};

export default WholeMeProfileCareerAspirations;
